export default "__VITE_ASSET__b5478c2d__"